(function () {
  const loader = document.querySelector('.se-pre-con'); 
  const body = document.body;
 
  function lockScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    body.dataset.scrollY = scrollY;
    body.classList.add('no-scroll', 'body-fixed');
    body.style.top = `-${scrollY}px`;
  }
 
  function unlockScroll() {
    body.classList.remove('no-scroll', 'body-fixed');
    const stored = parseInt(body.dataset.scrollY || '0', 10);
    body.style.top = '';
    window.scrollTo(0, stored);
    delete body.dataset.scrollY;
  }
 
  // window.hideLoader = function hideLoader(options = {}) {
  //   const wait = typeof options.waitForMs === 'number' ? options.waitForMs : 0;
 
  //   setTimeout(() => {
  //     if (!loader) return; 
  //     loader.classList.add('hidden');
 
  //     const transitionDuration = 350;
  //     setTimeout(() => {
  //       if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
  //       unlockScroll();
  //     }, transitionDuration);
  //   }, wait);
  // };
  window.hideLoader = function hideLoader(options = {}) {
  const isMobile = window.innerWidth <= 768;
  const wait = isMobile ? 50 : 200; // 100ms mobile, 200ms desktop

  setTimeout(() => {
    if (!loader) return; 
    loader.classList.add('hidden');

    const transitionDuration = isMobile ? 100 : 350; // Faster on mobile
    setTimeout(() => {
      if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
      unlockScroll();
    }, 10);
  }, wait);
};
 
  lockScroll();
 
  // window.addEventListener('load', function () {
  //   hideLoader({ waitForMs: 200 });
  // });

  window.addEventListener('load', function () {
  const isMobile = window.innerWidth <= 768;
  const loadWait = isMobile ? 50 : 200; // 100ms mobile, 200ms desktop
  hideLoader({ waitForMs: loadWait });
});
 
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideLoader();
    }
  });
 
  window.isLoaderVisible = () => !!document.querySelector('.se-pre-con');
})();

// Blind Ship Checkbox Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Blind Ship functionality
  initializeBlindShipCheckboxes();
  
  // Use event delegation for drawer checkbox (since it's dynamically rendered)
  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('ajaxcart__blind-ship-checkbox')) {
      handleDrawerBlindShipChange(e);
    }
  });
  
  // Handle Blind Ship checkbox in cart drawer - reinitialize when cart loads (jQuery event)
  if (typeof jQuery !== 'undefined') {
    jQuery('body').on('ajaxCart.afterCartLoad', function() {
      // Increased timeout to ensure cart is fully rendered after quantity updates
      setTimeout(() => {
        syncBlindShipCheckboxes();
      }, 300);
    });
    
    // Also listen for quantity changes to preserve Blind Ship state
    jQuery('body').on('click', '.ajaxcart__qty-adjust', function() {
      // Store current Blind Ship state before quantity change
      const currentCheckbox = document.querySelector('.ajaxcart__blind-ship-checkbox');
      if (currentCheckbox) {
        window._blindShipState = currentCheckbox.checked ? 'Yes' : 'No';
      }
    });
  }
  
  // Listen for drawer open events to sync checkboxes
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('js-drawer-open-right') || 
        e.target.closest('.js-drawer-open-right') ||
        e.target.closest('.site-header__cart-toggle')) {
      setTimeout(() => {
        syncBlindShipCheckboxes();
      }, 400);
    }
  });
  
  // Use MutationObserver to watch for drawer checkbox being added to DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node or its children contain the drawer checkbox
          const drawerCheckbox = node.querySelector ? node.querySelector('.ajaxcart__blind-ship-checkbox') : null;
          if (drawerCheckbox || (node.classList && node.classList.contains('ajaxcart__blind-ship-checkbox'))) {
            const checkbox = drawerCheckbox || node;
            setTimeout(() => {
              syncBlindShipCheckboxes();
            }, 100);
          }
        }
      });
    });
  });
  
  // Start observing the cart container
  const cartContainer = document.querySelector('#CartContainer');
  if (cartContainer) {
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});

// Initialize Blind Ship checkboxes
function initializeBlindShipCheckboxes() {
  // Use sync function which has better logic for preserving state
  syncBlindShipCheckboxes();
}

// Sync checkboxes between cart page and drawer
function syncBlindShipCheckboxes() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let blindShipValue = cart.attributes && cart.attributes['Blind Ship'];
      
      // If Blind Ship attribute is missing but we have a stored state, restore it
      if (!blindShipValue && window._blindShipState) {
        blindShipValue = window._blindShipState;
        // Restore the attribute value silently
        updateCartAttribute('Blind Ship', blindShipValue, true);
        // Clear the stored state
        delete window._blindShipState;
      }
      
      // If still no value, set default to "No"
      if (!blindShipValue) {
        blindShipValue = 'No';
        updateCartAttribute('Blind Ship', 'No', true);
      }
      
      const isBlindShipChecked = blindShipValue === 'Yes';
      
      // console.log('Syncing checkboxes - Cart attribute value:', blindShipValue, 'Checked:', isBlindShipChecked);
      
      // Sync cart page checkbox
      const cartCheckbox = document.querySelector('.cart__blind-ship-checkbox');
      if (cartCheckbox) {
        // Temporarily remove event listener to prevent triggering change event
        cartCheckbox.removeEventListener('change', handleCartBlindShipChange);
        cartCheckbox.checked = isBlindShipChecked;
        // Re-attach event listener
        cartCheckbox.addEventListener('change', handleCartBlindShipChange);
        // console.log('Cart page checkbox synced to:', isBlindShipChecked);
      }
      
      // Sync drawer checkbox with retry logic
      let syncAttempts = 0;
      const maxSyncAttempts = 20;
      
      const trySyncDrawerCheckbox = () => {
        const drawerCheckbox = document.querySelector('.ajaxcart__blind-ship-checkbox');
        if (drawerCheckbox) {
          // Set checkbox state (event delegation handles the change event)
          drawerCheckbox.checked = isBlindShipChecked;
          // console.log('Drawer checkbox synced to:', isBlindShipChecked, 'after', syncAttempts, 'attempts');
        } else if (syncAttempts < maxSyncAttempts) {
          syncAttempts++;
          setTimeout(trySyncDrawerCheckbox, 150);
        } else {
          // console.log('Drawer checkbox not found after', maxSyncAttempts, 'attempts');
        }
      };
      
      trySyncDrawerCheckbox();
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

// Handle cart page checkbox change
function handleCartBlindShipChange(e) {
  const isChecked = e.target.checked;
  updateCartAttribute('Blind Ship', isChecked ? 'Yes' : 'No', false, function() {
    // After cart attribute is updated, sync drawer checkbox
    const drawerCheckbox = document.querySelector('.ajaxcart__blind-ship-checkbox');
    if (drawerCheckbox) {
      // Set checkbox state (event delegation handles the change event)
      drawerCheckbox.checked = isChecked;
    }
  });
}

// Handle drawer checkbox change
function handleDrawerBlindShipChange(e) {
  const isChecked = e.target.checked;
  // console.log('Drawer checkbox changed to:', isChecked);
  
  updateCartAttribute('Blind Ship', isChecked ? 'Yes' : 'No', false, function() {
    // console.log('Cart attribute updated, syncing cart page checkbox');
    // After cart attribute is updated, sync cart page checkbox
    const cartCheckbox = document.querySelector('.cart__blind-ship-checkbox');
    if (cartCheckbox) {
      // Temporarily remove event listener to prevent loop
      cartCheckbox.removeEventListener('change', handleCartBlindShipChange);
      cartCheckbox.checked = isChecked;
      // Re-attach event listener
      cartCheckbox.addEventListener('change', handleCartBlindShipChange);
    }
  });
}

// Function to update cart attributes
function updateCartAttribute(attributeName, attributeValue, silent, callback) {
  // console.log('Updating cart attribute:', attributeName, 'to:', attributeValue);
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        [attributeName]: attributeValue
      }
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    if (!silent) {
      // console.log('Cart attribute updated successfully:', data);
      console.log('Updated attributes:', data.attributes);
    }
    // Execute callback if provided
    if (callback && typeof callback === 'function') {
      callback();
    }
  })
  .catch(error => {
    console.error('Error updating cart attribute:', error);
  });
}

//wholesale app when popup is open disbaled body scroll js start
$(document).ready(function () {
  var $popup = $("#wpd_product_option_popup_main_container");
  function toggleBodyScroll() {
      if ($popup.is(":visible")) {
          $("html, body").css({
              overflow: "hidden",
              height: "100%",
              position: "fixed",
              width: "100%"
          });
          $(".page-width, .site-wrapper, .content-for-layout, .theme-editor-scroll-container").css("overflow", "hidden");
      } else {
          $("html, body").css({
              overflow: "",
              height: "",
              position: "",
              width: ""
          });
          $(".page-width, .site-wrapper, .content-for-layout, .theme-editor-scroll-container")
              .css("overflow", "");
      }
  }
  toggleBodyScroll();
  var observer = new MutationObserver(function () {
      toggleBodyScroll();
  });
  observer.observe($popup[0], {
      attributes: true,
      attributeFilter: ["style", "class"]
  });
});
//wholesale app when popup is open disbaled body scroll js end